import React from 'react';
import { trans } from '@spotahome/soyuz/client';
import { CircleChecked, Clap, showToast } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Toast.css';

import { TOAST_TIMEOUT } from '../constants';

const DeleteToast = {
  renderIcon: () => <CircleChecked />,
  renderTitle: () => trans('alerts.toast.deleted.title'),
  renderContent: () => trans('alerts.toast.deleted.text')
};

const SuccessToast = {
  renderIcon: () => <Clap />,
  renderTitle: () => trans('alerts.toast.success.title'),
  renderContent: () => trans('alerts.toast.success.text')
};

const displayToast = toastProps => {
  showToast(toastProps, { autoClose: TOAST_TIMEOUT });
};

export const showDeleteToast = () => {
  displayToast(DeleteToast);
};

export const showSuccessToast = () => {
  displayToast(SuccessToast);
};

export default {
  showDeleteToast,
  showSuccessToast
};
